import React, { useEffect, useState } from 'react';
import { Card, Image } from 'react-bootstrap';
import { greenLogo, logo } from '../../utils/Logo';
import { useNavigate } from 'react-router-dom';
import { endpoints, POST, requestInfo } from '../../services/modulesServices/userManagement.api';
import { decode } from '../../utils/utils';
import Loading from '../../components/portalComponents/Loading.component';

export default function Verification() {
    const navigate = useNavigate();
    const url = window.location.href;
    const encryptedDataList = url?.split('data=');
    const encryptedData = encryptedDataList?.[encryptedDataList?.length - 1];

    const [VerificationData, setVerificationData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        const ThirdPartyVerification = async () => {
            try {
                setIsLoading(true);
                const payload = {
                    RequestInfo: requestInfo(),
                    encryptedData: decode(encryptedData)
                };
                const res = await POST(endpoints.thirdPartyVerification, payload);
                const resData = res?.data?.decryptedData;
                const JSONData = JSON.parse(resData || '{}');
                setVerificationData(JSONData);
                if (!JSONData?.orderId || !JSONData?.orderName || !JSONData?.lesseeName || !JSONData?.orderDate) {
                    setIsError(true);
                    setIsLoading(false);
                    return;
                }
                setIsLoading(false);
            } catch (e: any) {
                setIsLoading(false);
                setIsError(true);
            }
        };
        ThirdPartyVerification();
    }, []);

    const onLogoClick = () => {
        navigate('/goa-idc/');
    };

    return (
        <>
            {isLoading ? <Loading /> : <></>}
            <div className='third-party-verification-container'>
                <Card className='card_custom'>
                    <Card.Body className='content_custom'>
                        <div className='d-flex justify-content-between' style={{ display: 'flex', width: '100%' }}>
                            <div className='pe-4' style={{ cursor: 'pointer', width: '50%' }}>
                                <Image src={logo} width={'100%'} onClick={onLogoClick} />
                            </div>
                            <div className='ps-4 d-flex align-items-center' style={{ width: '50%' }}>
                                <div style={{ cursor: 'pointer' }}>
                                    <div>
                                        <Image src={greenLogo} width={'100%'} onClick={onLogoClick} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='py-5 pb-5'>
                            <div className='row_custom'>
                                <h3 className='heading'> Order ID:</h3>{' '}
                                <h3 className='detail' style={{ width: '70%' }}>
                                    {VerificationData?.orderId}
                                </h3>
                            </div>
                            <div className='row_custom'>
                                <h3 className='heading'>Order Name:</h3> <h3 className='detail'>{VerificationData?.orderName}</h3>
                            </div>
                            <div className='row_custom'>
                                <h3 className='heading'>Lessee Name:</h3> <h3 className='detail'>{VerificationData?.lesseeName}</h3>
                            </div>
                            <div className='row_custom'>
                                <h3 className='heading'>Order Date:</h3> <h3 className='detail'>{VerificationData?.orderDate}</h3>
                            </div>
                        </div>

                        <h4 className='font-18' style={{ color: !isError ? 'green' : 'red' }}>
                            {!isError ? 'This document has been verified by Goa IDC.' : 'Document verification unsuccessful!'}
                        </h4>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
}
